import React from 'react';
import { motion } from 'framer-motion';
import { ConsultationForm } from '../forms/ConsultationForm';
export function HeroSection() {
  return <section id="top" className="relative w-full bg-brand-charcoal" data-id="element-67" data-mp="26a8tzwy4utcd">
      <div className="relative min-h-[560px] w-full overflow-hidden sm:min-h-[620px]" data-id="element-68" data-mp="219b6r5y9n940">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/d4fcf2aa-6508-47d7-aa31-364c706facd0.jpg" alt="Bright kitchen with white marble waterfall island countertop" className="absolute inset-0 h-full w-full object-cover" data-id="element-69" data-mp="1x9j1b2465j2v" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-charcoal/85 via-brand-charcoal/50 to-brand-charcoal/10" data-id="element-70" data-mp="1ijldwoe2cxeq" />

        <div className="relative z-10 mx-auto flex h-full max-w-7xl flex-col justify-center gap-10 px-4 py-16 sm:px-6 lg:flex-row lg:items-center lg:gap-16 lg:px-8 lg:py-24" data-id="element-71" data-mp="1dltdf5zcs2yx">
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="max-w-xl" data-id="element-72" data-mp="14jk5mnvgynp8">
            <h1 className="font-display text-4xl leading-tight text-white sm:text-5xl" data-id="element-73" data-mp="2sp0ug891m4ke">
              The Saratoga Springs Area's Largest Selection of Kitchen Countertops
            </h1>
            <p className="mt-6 text-base leading-relaxed text-white/90 sm:text-lg" data-id="element-74" data-mp="3kforb83oons9">
              Choose from over 2,500 slabs and over 250 colors of natural stone — including
              granite, marble, onyx, and soapstone — and engineered quartz for countertops.
            </p>
            <p className="mt-4 text-sm leading-relaxed text-white/70" data-id="element-75" data-mp="3gc8xskmwv3js">
              Installations are available in Albany, Schenectady, Troy, Clifton Park, Latham,
              Saratoga Springs, Glens Falls, Queensbury, Waterford, Wilton, NY, and everywhere in
              between!
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.15,
          ease: 'easeOut'
        }} className="w-full max-w-md lg:ml-auto" data-id="element-76" data-mp="ah54pymhsezf">
            <ConsultationForm id="hero-form" title="Get A Free Consultation" data-id="element-77" data-mp="3nxkwevoqwrci" />
          </motion.div>
        </div>
      </div>
    </section>;
}